import {APIClient} from '../backend/ApiClient';
import {useState} from 'react';
import {StorageObject} from '../models/StorageObject';
import {isNullOrEmpty, isWatermarkApplicableCheck} from '../utils';

export interface DownloadResponse {
    readonly filename: string,
    readonly token: string
}

export const useDownloadFile = () => {
    const apiClient = APIClient();

    const [fileToDownload, setFileToDownload] = useState<StorageObject | null>(null);

    const downloadFile = async (file: StorageObject | null) => {
        if ((file === undefined) || (!file)) {
            return;
        }

        let fileId = file?.id;
        if ((fileId === undefined) || (isNullOrEmpty(fileId))) {
            return;
        }

        let applyWatermark = isWatermarkApplicableCheck(file.metadata.watermark);
        setFileToDownload(null);
        const response: DownloadResponse = await apiClient.downloadFile(fileId, applyWatermark);
        const element = document.createElement('a');
        element.setAttribute('href', response.token);
        element.setAttribute('download', response.filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        return;
    };

    return {fileToDownload, setFileToDownload, downloadFile};
};
